module.exports = __webpack_public_path__ + "img/search.f0f68099.svg";